import { render } from "./AdminAbout.vue?vue&type=template&id=7ba048bf&scoped=true"
import script from "./AdminAbout.vue?vue&type=script&lang=js"
export * from "./AdminAbout.vue?vue&type=script&lang=js"

import "./AdminAbout.vue?vue&type=style&index=0&id=7ba048bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba048bf"]])

export default __exports__